import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backupLink"]
  
  connect() {
    // Focus on the first input when the page loads
    const firstInput = this.element.querySelector('input[type="text"], input[type="password"]')
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100)
    }
  }
}